import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import spreadsheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import { Button as CustomButton, Input } from '../../../../styled'
import { getExpenseHistory, getExpenseHistoryLabels } from './expenseHistory'
import Header from './Header'
import PageContent from './page_content'

export default function Main() {

    const [modalOpen, setModalOpen] = useState(false)

    const handleOnHeaderButtonClick =()=>{
        setModalOpen(modalOpen ? false : true)
    }

    const handleOnExport = ()=>{

        let salesHistory = getExpenseHistory()
        let objKeys:(string|number)[][] = []

        salesHistory.forEach((history)=>{
            const arr = Object.values(history)
            objKeys.push(arr)
        })

        const aoa = [
            getExpenseHistoryLabels(),
            ...objKeys
        ]

        spreadsheet.aoaToSpreadSheet(aoa, "Expense history")
        setModalOpen(false)
        
        
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <Header handleOnHeaderButtonClick={handleOnHeaderButtonClick} />

            <PageContent/>

            <Modal
                title="Export expenses history"
                subtitle="Select time range to export data"
                visible={modalOpen}
                setVisibility={setModalOpen}
            >
                <Box
                >
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Start Date:</Typography>
                            <Input type="date" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">End Date:</Typography>
                            <Input type="date" />
                        </Stack>
                    </Stack>

                    <Box
                        sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                    >
                        
                        <CustomButton 
                            startIcon={<BsFileEarmarkArrowDown />} 
                            variant="contained" 
                            color="secondary" 
                            disableElevation={true}
                            onClick={handleOnExport}
                        >
                            <Typography  color="primary" sx={{fontSize:"13px"}} >Download</Typography>
                        </CustomButton>
                    </Box>

                </Box>
            </Modal>


        </Stack>
    )

}


